<template>
  <router-link :to="to">
    <slot />
  </router-link>
</template>
<script>
import { DEPARTMENTS_URL } from '@/modules/department/department.constants';

export default {
  name: 'DaraDepartmentLink',
  props: {
    id: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: 'view',
      validator(action) {
        return action && ['view', 'edit'].includes(action);
      },
    },
  },
  computed: {
    to() {
      if (this.slug) {
        return {
          name: DEPARTMENTS_URL[this.action].name,
          path: DEPARTMENTS_URL[this.action].path,
          params: { id: this.id },
          query: { name: this.slug },
        };
      }
      return {
        name: DEPARTMENTS_URL[this.action].name,
        path: DEPARTMENTS_URL[this.action].path,
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>
